import { PROTOCOL } from '../partner';
import {
  AdvancedQueryTypes,
  PaginationParams,
  Provider,
  VDriveProvider,
} from '../shared.types';

export type GetBrandOwnerDashboardTodayParams = {
  type: string;
  timeZone: string;
};

export type GetPartnerDashboardTodayParams = {
  type: AdvancedQueryTypes;
  locationIds?: (number | string)[];
  brandIds?: (number | string)[];
  timeZone: string;
};

export type GetBrandOwnerDashboardOverviewParams = {
  from?: string | Date;
  to?: string | Date;
  type: string;
  periodType: PeriodType;
  timeZone: string;
  groupByType: GroupByType;
};

export type GetPartnerDashboardOverviewParams = {
  from?: string | Date;
  to?: string | Date;
  type: AdvancedQueryTypes;
  periodType: PeriodType;
  timeZone: string;
  groupByType: GroupByType;
  locationIds?: (number | string)[];
  brandIds?: (number | string)[];
};

export enum PeriodType {
  CUSTOM = 'custom',
  LAST_MONTH = 'last_month',
  LAST_QUARTER = 'last_quarter',
  LAST_YEAR = 'last_year',
}

export enum ComparedPeriodType {
  LAST_MONTH = 'previous_month',
  LAST_YEAR = 'previous_year',
  CUSTOM = 'custom',
}

export enum GroupByType {
  HOUR = 'hour',
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year',
}

export type GetBrandOwnerDashboardBestPerformingParams = PaginationParams & {
  type: string;
};

export type GetBrandOwnerDashboardCustomerOverviewParams = {
  type: string;
};

//ORDERS TODAY

export type OrdersTodayInfoEntity = {
  totalSalesByProvider: OrdersTotalSalesByProviderEntity[];
  totalSales: number;
  totalOrdersCountByProvider: OrdersTotalOrdersCountByProviderEntity[];
  totalOrdersCount: 0;
  totalTaxesByProvider: OrdersTotalTaxesByProviderEntity[];
  totalTaxes: 0;
  totalRecoveredByProvider: OrdersTotalRecoveredByProviderEntity[];
  totalRecovered: 0;
  totalCancelledByProvider: OrdersTotalCancelledByProviderEntity[];
  totalCancelled: 0;
};

export type OrdersTotalSalesByProviderEntity = {
  provider: Provider;
  totalSales: number;
};

export type OrdersTotalOrdersCountByProviderEntity = {
  provider: Provider;
  totalOrdersCount: number;
};

export type OrdersTotalTaxesByProviderEntity = {
  provider: Provider;
  totalTaxes: number;
};

export type OrdersTotalRecoveredByProviderEntity = {
  provider: Provider;
  totalRecovered: number;
};

export type OrdersTotalCancelledByProviderEntity = {
  provider: Provider;
  totalCancelled: number;
};

//ORDERS OVERVIEW

export type OrdersOverviewEntity = {
  totalSalesByProvider: OrdersOverviewTotalSalesByProviderEntity[];
  totalSales: OrdersOverviewTotalSalesEntity[];
  totalSalesSum: number;

  totalTaxesByProvider: OrdersOverviewTotalTaxesByProviderEntity[];
  totalTaxes: OrdersOverviewTotalTaxesEntity[];
  totalTaxesSum: number;

  totalOrdersByProvider: OrdersOverviewTotalOrdersByProviderEntity[];
  totalOrders: OrdersOverviewTotalOrdersEntity[];
  totalOrdersCount: number;

  totalRecoveredByProvider: OrdersOverviewTotalRecoveredByProviderEntity[];
  totalRecovered: OrdersOverviewTotalRecoveredEntity[];
  totalRecoveredSum: number;

  totalCancelledByProvider: OrdersOverviewTotalCancelledByProviderEntity[];
  totalCancelled: OrdersOverviewTotalCancelledEntity[];
  totalCancelledCount: number;
};

export type OrdersOverviewPartnerLocationDetailsEntity = {
  totalVGrubsOrders: OrdersOverviewTotalOrdersEntity[];
  totalVGrubsOrdersByProvider: OrdersOverviewTotalOrdersByProviderEntity[];
  totalVGrubsOrdersCount: number;

  totalTaxesByProvider: OrdersOverviewTotalTaxesByProviderEntity[];
  totalTaxes: OrdersOverviewTotalTaxesEntity[];
  totalTaxesSum: number;

  totalLocationSalesByProvider: OrdersOverviewTotalSalesByProviderEntity[];
  totalLocationSales: OrdersOverviewTotalSalesEntity[];
  totalLocationSalesSum: number;

  totalRecoveredByProvider: OrdersOverviewTotalRecoveredByProviderEntity[];
  totalRecovered: OrdersOverviewTotalRecoveredEntity[];
  totalRecoveredSum: number;

  totalLocationOrdersByProvider: OrdersOverviewTotalOrdersByProviderEntity[];
  totalLocationOrders: OrdersOverviewTotalOrdersEntity[];
  totalLocationOrdersCount: number;

  totalCombinedSalesByProvider: OrdersOverviewTotalSalesByProviderEntity[];
  totalCombinedSales: OrdersOverviewTotalSalesEntity[];
  totalCombinedSalesSum: number;
};

export type OrdersOverviewTotalSalesByProviderEntity = {
  provider: Provider;
  totalSales: OrdersOverviewTotalSalesEntity[];
  totalSalesSum: number;
};

export type OrdersOverviewTotalSalesEntity = {
  key: string;
  totalSales: number;
};

export type OrdersOverviewTotalTaxesByProviderEntity = {
  provider: Provider;
  totalTaxes: OrdersOverviewTotalTaxesEntity[];
  totalTaxesSum: number;
};

export type OrdersOverviewTotalTaxesEntity = {
  key: string;
  totalTaxes: number;
};

export type OrdersOverviewTotalOrdersByProviderEntity = {
  provider: Provider;
  totalOrders: OrdersOverviewTotalOrdersEntity[];
  totalOrdersCount: number;
};

export type OrdersOverviewTotalOrdersEntity = {
  key: string;
  totalOrders: number;
};

export type OrdersOverviewTotalRecoveredByProviderEntity = {
  provider: Provider;
  totalRecovered: OrdersOverviewTotalRecoveredEntity[];
  totalRecoveredSum: number;
};

export type OrdersOverviewTotalRecoveredEntity = {
  key: string;
  totalRecovered: number;
};

export type OrdersOverviewTotalCancelledByProviderEntity = {
  provider: Provider;
  totalCancelled: OrdersOverviewTotalCancelledEntity[];
  totalCancelledCount: number;
};

export type OrdersOverviewTotalCancelledEntity = {
  key: string;
  totalCancelled: number;
};

//ORDERS OVERVIEW COMPARED

export type ComparedOrdersOverviewEntity = {
  comparedTotalSalesByProvider: OrdersOverviewComparedTotalSalesByProviderEntity[];
  comparedTotalSales: OrdersOverviewComparedTotalSalesEntity[];
  totalSalesSum: number;
  totalSalesSumToCompare: number;

  comparedTotalTaxesByProvider: OrdersOverviewComparedTotalTaxesByProviderEntity[];
  comparedTotalTaxes: OrdersOverviewComparedTotalTaxesEntity[];
  totalTaxesSum: number;
  totalTaxesSumToCompare: number;

  comparedTotalOrdersByProvider: OrdersOverviewComparedTotalOrdersByProviderEntity[];
  comparedTotalOrders: OrdersOverviewComparedTotalOrdersEntity[];
  totalOrdersCount: number;
  totalOrdersCountToCompare: number;

  comparedTotalRecoveredByProvider: OrdersOverviewComparedTotalRecoveredByProviderEntity[];
  comparedTotalRecovered: OrdersOverviewComparedTotalRecoveredEntity[];
  totalRecoveredSum: number;
  totalRecoveredSumToCompare: number;

  comparedTotalCancelledByProvider: OrdersOverviewComparedTotalCancelledByProviderEntity[];
  comparedTotalCancelled: OrdersOverviewComparedTotalCancelledEntity[];
  totalCancelledCount: number;
  totalCancelledCountToCompare: number;
};

export type OrdersOverviewComparedTotalSalesByProviderEntity = {
  provider: Provider;
  comparedTotalSales: OrdersOverviewComparedTotalSalesEntity[];
  totalSalesSum: number;
  totalSalesPercentage: number;
  totalSalesSumToCompare: number;
  totalSalesPercentageToCompare: number;
};

export type OrdersOverviewComparedTotalSalesEntity = {
  key: string;
  totalSales: OrdersOverviewTotalSalesEntity;
  totalSalesToCompare: OrdersOverviewTotalSalesEntity;
};

export type OrdersOverviewComparedTotalTaxesByProviderEntity = {
  provider: Provider;
  comparedTotalTaxes: OrdersOverviewComparedTotalTaxesEntity[];
  totalTaxesSum: number;
  totalTaxesPercentage: number;
  totalTaxesSumToCompare: number;
  totalTaxesPercentageToCompare: number;
};

export type OrdersOverviewComparedTotalTaxesEntity = {
  key: string;
  totalTaxes: OrdersOverviewTotalTaxesEntity;
  totalTaxesToCompare: OrdersOverviewTotalTaxesEntity;
};

export type OrdersOverviewComparedTotalOrdersByProviderEntity = {
  provider: Provider;
  comparedTotalOrders: OrdersOverviewComparedTotalOrdersEntity[];
  totalOrdersCount: number;
  totalOrdersPercentage: number;
  totalOrdersCountToCompare: number;
  totalOrdersPercentageToCompare: number;
};

export type OrdersOverviewComparedTotalOrdersEntity = {
  key: string;
  totalOrders: OrdersOverviewTotalOrdersEntity;
  totalOrdersToCompare: OrdersOverviewTotalOrdersEntity;
};

export type OrdersOverviewComparedTotalRecoveredByProviderEntity = {
  provider: Provider;
  comparedTotalRecovered: OrdersOverviewComparedTotalRecoveredEntity[];
  totalRecoveredSum: number;
  totalRecoveredPercentage: number;
  totalRecoveredSumToCompare: number;
  totalRecoveredPercentageToCompare: number;
};

export type OrdersOverviewComparedTotalRecoveredEntity = {
  key: string;
  totalRecovered: OrdersOverviewTotalRecoveredEntity;
  totalRecoveredToCompare: OrdersOverviewTotalRecoveredEntity;
};

export type OrdersOverviewComparedTotalCancelledByProviderEntity = {
  provider: Provider;
  comparedTotalCancelled: OrdersOverviewComparedTotalCancelledEntity[];
  totalCancelledCount: number;
  totalCancelledCountToCompare: number;
  totalCancelledPercentage: number;
  totalCancelledPercentageToCompare: number;
};

export type OrdersOverviewComparedTotalCancelledEntity = {
  key: string;
  totalCancelled: OrdersOverviewTotalCancelledEntity;
  totalCancelledToCompare: OrdersOverviewTotalCancelledEntity;
};

//BEST PERFORMING

export type BestPerformingLocationsEntity = {
  id: number;
  name: string;
  totalSales: number;
  totalOrders: number;
};

export type BestPerformingBrandsEntity = {
  id: string;
  name: string;
  totalSales: number;
  totalOrders: number;
  imageUrl: string | null;
};

export type BestPerformingStateEntity = {
  state: string;
  totalSales: number;
  totalOrders: number;
};

export type BestPerformingProviderEntity = {
  provider: Provider;
  totalSales: number;
  totalOrders: number;
};

export type BestPerformingFleetEntity = {
  provider: VDriveProvider;
  totalSales: number;
  totalOrders: number;
};

export type SuccessRateEntity = {
  successPercentage: number;
  failurePercentage: number;
  totalDeliveries: number;
  successfulDeliveries: number;
  failedDeliveries: number;
};

export type TrackingSuccessRateEntity = {
  successPercentage: number;
  failurePercentage: number;
  totalMessages: number;
  successfulMessages: number;
  failedMessages: number;
};

export type ClientsOverHundredEntity = {
  id: number;
  name: string;
  amount: number;
  lastActiveAt: string;
};

export type FinancesWithdrawalEntity = {
  id: number;
  name: string;
  amount: number;
  lastActiveAt?: string | null;
  createdAt: string;
  protocol: PROTOCOL;
  completedAt?: string | null;
};

//CUSTOMERS OVERVIEW

export type CustomersOverviewEntity = {
  newCustomers: number;
  newCustomersPercentage: number;
  returningCustomers: number;
  returningCustomersPercentage: number;
  totalCustomers: number;
};

//DELIVERIES TODAY

export type DeliveriesTodayInfoEntity = {
  totalSalesByProvider: DeliveriesTotalSalesByProviderEntity[];
  totalSales: number;

  totalCompletedCountByProvider: DeliveriesTotalCompletedCountByProviderEntity[];
  totalCompletedCount: number;

  totalCancelledCountByProvider: DeliveriesTotalCompletedCountByProviderEntity[];
  totalCancelledCount: number;

  totalTaxesByProvider: DeliveriesTotalDSPFeesByProviderEntity[];
  totalTaxes: number;

  totalTipsByProvider: DeliveriesTotalTipsByProviderEntity[];
  totalTips: number;

  averageTipsByProvider: DeliveriesAverageTipsByProviderEntity[];
  averageTips: number;

  averageDeliveryTimeByProvider: DeliveriesAverageDeliveryTimeByProviderEntity[];
  averageDeliveryTime: number;

  averageAssignmentTimeByProvider: DeliveriesAverageAssignmentTimeByProviderEntity[];
  averageAssignmentTime: number;

  activeStoresCount: number;
  activeStoresList: BestPerformingLocationsEntity[];
};

export type DeliveriesTotalSalesByProviderEntity = {
  provider: VDriveProvider;
  totalSales: number;
  totalSalesPercentage: number;
};

export type DeliveriesTotalCompletedCountByProviderEntity = {
  provider: VDriveProvider;
  totalDeliveriesCount: number;
  totalDeliveriesCountPercentage: number;
};

export type DeliveriesTotalDSPFeesByProviderEntity = {
  provider: VDriveProvider;
  totalDSPFees: number;
  totalDSPFeesPercentage: number;
};

export type DeliveriesTotalTipsByProviderEntity = {
  provider: VDriveProvider;
  totalTips: number;
  totalTipsPercentage: number;
};

export type DeliveriesAverageTipsByProviderEntity = {
  provider: VDriveProvider;
  averageTips: number;
  averageTipsPercentage: number;
};

export type DeliveriesAverageDeliveryTimeByProviderEntity = {
  provider: VDriveProvider;
  averageDeliveryTime: number;
};

export type DeliveriesAverageAssignmentTimeByProviderEntity = {
  provider: VDriveProvider;
  averageAssignmentTime: number;
};

//DELIVERIES OVERVIEW

export type DeliveriesOverviewEntity = {
  totalSalesByProvider: DeliveriesOverviewTotalSalesByProviderEntity[];
  totalSales: DeliveriesOverviewTotalSalesEntity[];
  totalSalesSum: number;

  totalTipsByProvider: DeliveriesOverviewTotalTipsByProviderEntity[];
  totalTips: DeliveriesOverviewTotalTipsEntity[];
  totalTipsSum: number;

  totalDSPFeesByProvider: DeliveriesOverviewTotalDSPFeesByProviderEntity[];
  totalDSPFees: DeliveriesOverviewTotalDSPFeesEntity[];
  totalDSPFeesSum: number;

  totalCompletedByProvider: DeliveriesOverviewTotalCompletedByProviderEntity[];
  totalCompleted: DeliveriesOverviewTotalCompletedEntity[];
  totalCompletedCount: number;

  totalCancelledByProvider: DeliveriesOverviewTotalCancelledByProviderEntity[];
  totalCancelled: DeliveriesOverviewTotalCancelledEntity[];
  totalCancelledCount: number;

  averageDeliveryTimeByProvider: DeliveriesOverviewAverageDeliveryTimeByProviderEntity[];
  averageDeliveryTime: DeliveriesOverviewAverageDeliveryTimeEntity[];
  averageDeliveryTimeAverage: number;

  averageAssignmentTimeByProvider: DeliveriesOverviewAverageAssignmentTimeByProviderEntity[];
  averageAssignmentTime: DeliveriesOverviewAverageAssignmentTimeEntity[];
  averageAssignmentTimeAverage: number;

  averageTipsByProvider: DeliveriesOverviewAverageTipsByProviderEntity[];
  averageTips: DeliveriesOverviewAverageTipsEntity[];
  averageTipsAverage: number;

  activeStores: DeliveriesOverviewActiveStoresEntity[];
  activeStoresCount: number;
  activeStoresList: BestPerformingLocationsEntity[];
};

export type DeliveriesOverviewActiveStoresEntity = {
  key: string;
  activeStores: number;
};

export type DeliveriesOverviewTotalSalesByProviderEntity = {
  provider: VDriveProvider;
  totalSales: DeliveriesOverviewTotalSalesEntity[];
  totalSalesSum: number;
  totalSalesPercentage: number;
};

export type DeliveriesOverviewTotalSalesEntity = {
  key: string;
  totalSales: number;
};

export type DeliveriesOverviewTotalTipsByProviderEntity = {
  provider: VDriveProvider;
  totalTips: DeliveriesOverviewTotalTipsEntity[];
  totalTipsSum: number;
  totalTipsPercentage: number;
};

export type DeliveriesOverviewTotalTipsEntity = {
  key: string;
  totalTips: number;
};

export type DeliveriesOverviewTotalDSPFeesByProviderEntity = {
  provider: VDriveProvider;
  totalDSPFees: DeliveriesOverviewTotalDSPFeesEntity[];
  totalDSPFeesSum: number;
  totalDSPFeesPercentage: number;
};

export type DeliveriesOverviewTotalDSPFeesEntity = {
  key: string;
  totalDSPFees: number;
};

export type DeliveriesOverviewTotalCompletedByProviderEntity = {
  provider: VDriveProvider;
  totalCompleted: DeliveriesOverviewTotalCompletedEntity[];
  totalCompletedCount: number;
  totalCompletedPercentage: number;
};

export type DeliveriesOverviewTotalCompletedEntity = {
  key: string;
  totalCompleted: number;
};

export type DeliveriesOverviewTotalCancelledByProviderEntity = {
  provider: VDriveProvider;
  totalCancelled: DeliveriesOverviewTotalCancelledEntity[];
  totalCancelledCount: number;
  totalCancelledPercentage: number;
};

export type DeliveriesOverviewTotalCancelledEntity = {
  key: string;
  totalCancelled: number;
};

export type DeliveriesOverviewAverageDeliveryTimeByProviderEntity = {
  provider: VDriveProvider;
  averageDeliveryTime: DeliveriesOverviewAverageDeliveryTimeEntity[];
  averageDeliveryTimeSum: number;
  averageDeliveryTimePercentage: number;
};

export type DeliveriesOverviewAverageDeliveryTimeEntity = {
  key: string;
  averageDeliveryTime: number;
};

export type DeliveriesOverviewAverageAssignmentTimeByProviderEntity = {
  provider: VDriveProvider;
  averageAssignmentTime: DeliveriesOverviewAverageAssignmentTimeEntity[];
  averageAssignmentTimeSum: number;
  averageAssignmentTimePercentage: number;
};

export type DeliveriesOverviewAverageAssignmentTimeEntity = {
  key: string;
  averageAssignmentTime: number;
};

export type DeliveriesOverviewAverageTipsByProviderEntity = {
  provider: VDriveProvider;
  averageTips: DeliveriesOverviewAverageTipsEntity[];
  averageTipsSum: number;
  averageTipsPercentage: number;
};

export type DeliveriesOverviewAverageTipsEntity = {
  key: string;
  averageTips: number;
};

//DELIVERIES OVERVIEW COMPARED

export type ComparedDeliveriesOverviewEntity = {
  comparedTotalSalesByProvider: DeliveriesOverviewComparedTotalSalesByProviderEntity[];
  comparedTotalSales: DeliveriesOverviewComparedTotalSalesEntity[];
  totalSalesSum: number;
  totalSalesSumToCompare: number;

  comparedTotalTipsByProvider: DeliveriesOverviewComparedTotalTipsByProviderEntity[];
  comparedTotalTips: DeliveriesOverviewComparedTotalTipsEntity[];
  totalTipsSum: number;
  totalTipsSumToCompare: number;

  comparedTotalDSPFeesByProvider: DeliveriesOverviewComparedTotalDSPFeesByProviderEntity[];
  comparedTotalDSPFees: DeliveriesOverviewComparedTotalDSPFeesEntity[];
  totalDSPFeesSum: number;
  totalDSPFeesSumToCompare: number;

  comparedTotalCompletedByProvider: DeliveriesOverviewComparedTotalCompletedByProviderEntity[];
  comparedTotalCompleted: DeliveriesOverviewComparedTotalCompletedEntity[];
  totalCompletedCount: number;
  totalCompletedCountToCompare: number;

  comparedTotalCancelledByProvider: DeliveriesOverviewComparedTotalCancelledByProviderEntity[];
  comparedTotalCancelled: DeliveriesOverviewComparedTotalCancelledEntity[];
  totalCancelledCount: number;
  totalCancelledCountToCompare: number;

  comparedAverageDeliveryTimeByProvider: DeliveriesOverviewComparedAverageDeliveryTimeByProviderEntity[];
  comparedAverageDeliveryTime: DeliveriesOverviewComparedAverageDeliveryTimeEntity[];
  averageDeliveryTimeAverage: number;
  averageDeliveryTimeAverageToCompare: number;

  comparedAverageAssignmentTimeByProvider: DeliveriesOverviewComparedAverageAssignmentTimeByProviderEntity[];
  comparedAverageAssignmentTime: DeliveriesOverviewComparedAverageAssignmentTimeEntity[];
  averageAssignmentTimeAverage: number;
  averageAssignmentTimeAverageToCompare: number;

  comparedAverageTipsByProvider: DeliveriesOverviewComparedAverageTipsByProviderEntity[];
  comparedAverageTips: DeliveriesOverviewComparedAverageTipsEntity[];
  averageTipsAverage: number;
  averageTipsAverageToCompare: number;

  comparedActiveStores: DeliveriesOverviewComparedActiveStoresEntity[];
  activeStoresCount: number;
  activeStoresCountToCompare: number;
  activeStoresList: BestPerformingLocationsEntity[];
  activeStoresListToCompare: BestPerformingLocationsEntity[];
};

export type DeliveriesOverviewComparedActiveStoresEntity = {
  key: string;
  activeStores: DeliveriesOverviewActiveStoresEntity | null;
  activeStoresToCompare: DeliveriesOverviewActiveStoresEntity | null;
};

export type DeliveriesOverviewComparedTotalSalesByProviderEntity = {
  provider: VDriveProvider;
  comparedTotalSales: DeliveriesOverviewComparedTotalSalesEntity[];
  totalSalesSum: number;
  totalSalesPercentage: number;
  totalSalesSumToCompare: number;
  totalSalesPercentageToCompare: number;
};

export type DeliveriesOverviewComparedTotalSalesEntity = {
  key: string;
  totalSales: DeliveriesOverviewTotalSalesEntity;
  totalSalesToCompare: DeliveriesOverviewTotalSalesEntity;
};

export type DeliveriesOverviewComparedTotalTipsByProviderEntity = {
  provider: VDriveProvider;
  comparedTotalTips: DeliveriesOverviewComparedTotalTipsEntity[];
  totalTipsSum: number;
  totalTipsPercentage: number;
  totalTipsSumToCompare: number;
  totalTipsPercentageToCompare: number;
};

export type DeliveriesOverviewComparedTotalTipsEntity = {
  key: string;
  totalTips: DeliveriesOverviewTotalTipsEntity;
  totalTipsToCompare: DeliveriesOverviewTotalTipsEntity;
};

export type DeliveriesOverviewComparedTotalDSPFeesByProviderEntity = {
  provider: VDriveProvider;
  comparedTotalDSPFees: DeliveriesOverviewComparedTotalDSPFeesEntity[];
  totalDSPFeesSum: number;
  totalDSPFeesPercentage: number;
  totalDSPFeesSumToCompare: number;
  totalDSPFeesPercentageToCompare: number;
};

export type DeliveriesOverviewComparedTotalDSPFeesEntity = {
  key: string;
  totalDSPFees: DeliveriesOverviewTotalDSPFeesEntity;
  totalDSPFeesToCompare: DeliveriesOverviewTotalDSPFeesEntity;
};

export type DeliveriesOverviewComparedTotalCompletedByProviderEntity = {
  provider: VDriveProvider;
  comparedTotalCompleted: DeliveriesOverviewComparedTotalCompletedEntity[];
  totalCompletedCount: number;
  totalCompletedPercentage: number;
  totalCompletedCountToCompare: number;
  totalCompletedPercentageToCompare: number;
};

export type DeliveriesOverviewComparedTotalCompletedEntity = {
  key: string;
  totalCompleted: DeliveriesOverviewTotalCompletedEntity;
  totalCompletedToCompare: DeliveriesOverviewTotalCompletedEntity;
};

export type DeliveriesOverviewComparedTotalCancelledByProviderEntity = {
  provider: VDriveProvider;
  comparedTotalCancelled: DeliveriesOverviewComparedTotalCancelledEntity[];
  totalCancelledCount: number;
  totalCancelledPercentage: number;
  totalCancelledCountToCompare: number;
  totalCancelledPercentageToCompare: number;
};

export type DeliveriesOverviewComparedTotalCancelledEntity = {
  key: string;
  totalCancelled: DeliveriesOverviewTotalCancelledEntity;
  totalCancelledToCompare: DeliveriesOverviewTotalCancelledEntity;
};

export type DeliveriesOverviewComparedAverageDeliveryTimeByProviderEntity = {
  provider: VDriveProvider;
  comparedAverageDeliveryTime: DeliveriesOverviewComparedAverageDeliveryTimeEntity[];
  averageDeliveryTimeSum: number;
  averageDeliveryTimePercentage: number;
  averageDeliveryTimeSumToCompare: number;
  averageDeliveryTimePercentageToCompare: number;
};

export type DeliveriesOverviewComparedAverageDeliveryTimeEntity = {
  key: string;
  averageDeliveryTime: DeliveriesOverviewAverageDeliveryTimeEntity;
  averageDeliveryTimeToCompare: DeliveriesOverviewAverageDeliveryTimeEntity;
};

export type DeliveriesOverviewComparedAverageAssignmentTimeByProviderEntity = {
  provider: VDriveProvider;
  comparedAverageAssignmentTime: DeliveriesOverviewComparedAverageAssignmentTimeEntity[];
  averageAssignmentTimeSum: number;
  averageAssignmentTimePercentage: number;
  averageAssignmentTimeSumToCompare: number;
  averageAssignmentTimePercentageToCompare: number;
};

export type DeliveriesOverviewComparedAverageAssignmentTimeEntity = {
  key: string;
  averageAssignmentTime: DeliveriesOverviewAverageAssignmentTimeEntity;
  averageAssignmentTimeToCompare: DeliveriesOverviewAverageAssignmentTimeEntity;
};

export type DeliveriesOverviewComparedAverageTipsByProviderEntity = {
  provider: VDriveProvider;
  comparedAverageTips: DeliveriesOverviewComparedAverageTipsEntity[];
  averageTipsSum: number;
  averageTipsPercentage: number;
  averageTipsSumToCompare: number;
  averageTipsPercentageToCompare: number;
};

export type DeliveriesOverviewComparedAverageTipsEntity = {
  key: string;
  averageTips: DeliveriesOverviewAverageTipsEntity;
  averageTipsToCompare: DeliveriesOverviewAverageTipsEntity;
};
